import type React from "react"
import { useTranslation } from "react-i18next"

import { APP_NAME } from "@/utils/constants"

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material"

interface AboutDialogProps {
  open: boolean
  onClose: () => void
}

export const AboutDialog: React.FC<AboutDialogProps> = ({ open, onClose }) => {
  const { t } = useTranslation()

  return (
    <Dialog
      aria-labelledby="aboutDialogTitle"
      fullWidth
      maxWidth="xs"
      onClose={onClose}
      open={open}
    >
      <DialogContent>
        <Box sx={{ pt: 3, textAlign: "center" }}>
          <Typography
            id="aboutDialogTitle"
            variant="h1"
            sx={{
              mb: 4,
            }}
          >
            {t("about.title", { appName: APP_NAME })}
          </Typography>
          <Typography>
            {t("about.versionLabel")}: {process.env.APP_VERSION}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button onClick={onClose} variant="contained">
          {t("button.close")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
